import { checkEnvironment } from '@saviynt/common';

const getCheckInApiUrl = () => {
  const { PAMMS_API_URL } = checkEnvironment();

  return `${PAMMS_API_URL}/sessions/status`;
};

export default getCheckInApiUrl;
